/**
 * CompactChip — the lightweight, one-line rendering of a SECONDARY widget (or
 * every widget on an all-compact turn). Domain-tinted pill with a headline
 * value, visibly lighter than a full card. Presentation is client policy; it can
 * evolve without touching which widget the server marked primary.
 */
import React from 'react'
import { useTranslation } from 'react-i18next'
import { CopilotWidget } from '../lib/copilotTypes'
import { widgetDomain } from './format'
import { buildHeadline } from './headline'
import { domainGlyph } from './atoms'
import styles from './widgets.module.scss'

const hexToRgba = (hex: string, alpha: number): string => {
  const m = /^#?([\da-f]{2})([\da-f]{2})([\da-f]{2})$/i.exec(hex)
  if (!m) return hex
  return `rgba(${parseInt(m[1], 16)}, ${parseInt(m[2], 16)}, ${parseInt(m[3], 16)}, ${alpha})`
}

const CompactChip: React.FC<{ widget: CopilotWidget }> = ({ widget }) => {
  const { t } = useTranslation()
  const dom = widgetDomain(widget.type)
  const value = buildHeadline(widget)
  return (
    <span
      className={styles.chip}
      style={{ background: hexToRgba(dom.color, 0.1), color: dom.color, borderColor: hexToRgba(dom.color, 0.28) }}>
      <span className={styles.chipGlyph}>{domainGlyph(dom.key, styles.chipGlyphSvg)}</span>
      <span className={styles.chipLabel}>{t(dom.labelKey)}</span>
      {value && <span className={styles.chipValue}>{value}</span>}
    </span>
  )
}

export default CompactChip
